import { QueryClient } from '@tanstack/react-query'

// 전역 QueryClient — React Query 설정
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 창 포커스 시 자동 재요청 비활성화 (SaaS 대시보드 UX 개선)
      refetchOnWindowFocus: false,
      // 네트워크 에러 재시도 1회 — 단, 4xx (특히 404/401/403) 는 즉시 실패
      // (삭제된 리소스에 background refetch 가 폴링되는 것 방지)
      retry: (failureCount, err: any) => {
        const status = err?.response?.status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 1
      },
      staleTime: 1000 * 60 * 5, // 5분
    },
    mutations: {
      retry: 0,
    },
  },
})
